import React from "react";
import { BiLoaderAlt } from "react-icons/bi";

const NoEvent = () => {
  return (
    <div class="flex justify-center items-center py-48">
      <div class="pt-6 px-7 pb-5 bg-white text-center text-black-700 text-base rounded-xl leading-tight">
        <div
          alt=""
          class="icon-empty text-40 text-black-300 m-auto mb-2.5"
        ></div>
        <div>No Event</div>
      </div>
    </div>
  );
};

export default NoEvent;
